import type { MetersModule } from '@/types/organization'
import type {
	ActionsMetricsResponse,
	ApiKeysMetricsResponse,
	CombinedOrgMetricsResponse,
	DbcMetricsResponse,
	GeneralMetricsResponse,
	SessionsMetricsResponse,
	StreamsMetricsResponse,
} from '@/types/organization-owner-api'
import { fetchOrganizationMeters } from '../organizationMetricsMappers'
import { demoApi } from './db'

export const demoOrganizationMetricsApi = {
	getAllMetrics: async (organizationId: string): Promise<CombinedOrgMetricsResponse> =>
		demoApi.getNoTenant<CombinedOrgMetricsResponse>(`/organizations/${organizationId}/metrics`),
	getDevicesMeters: async (organizationId: string): Promise<GeneralMetricsResponse> =>
		demoApi.getNoTenant<GeneralMetricsResponse>(`/organizations/${organizationId}/metrics/devices`),
	getDashboardsMeters: async (organizationId: string): Promise<GeneralMetricsResponse> =>
		demoApi.getNoTenant<GeneralMetricsResponse>(`/organizations/${organizationId}/metrics/dashboards`),
	getActionsMeters: async (organizationId: string): Promise<ActionsMetricsResponse> =>
		demoApi.getNoTenant<ActionsMetricsResponse>(`/organizations/${organizationId}/metrics/actions`),
	getSessionsMeters: async (organizationId: string): Promise<SessionsMetricsResponse> =>
		demoApi.getNoTenant<SessionsMetricsResponse>(`/organizations/${organizationId}/metrics/sessions`),
	getDbcMeters: async (organizationId: string): Promise<DbcMetricsResponse> =>
		demoApi.getNoTenant<DbcMetricsResponse>(`/organizations/${organizationId}/metrics/dbc`),
	getExportersMeters: async (organizationId: string): Promise<GeneralMetricsResponse> =>
		demoApi.getNoTenant<GeneralMetricsResponse>(`/organizations/${organizationId}/metrics/exporters`),
	getStreamsMeters: async (organizationId: string): Promise<StreamsMetricsResponse> =>
		demoApi.getNoTenant<StreamsMetricsResponse>(`/organizations/${organizationId}/metrics/streams`),
	getUsersMeters: async (organizationId: string): Promise<GeneralMetricsResponse> =>
		demoApi.getNoTenant<GeneralMetricsResponse>(`/organizations/${organizationId}/metrics/users`),
	getRolesMeters: async (organizationId: string): Promise<GeneralMetricsResponse> =>
		demoApi.getNoTenant<GeneralMetricsResponse>(`/organizations/${organizationId}/metrics/roles`),
	getMetadataMeters: async (organizationId: string): Promise<GeneralMetricsResponse> =>
		demoApi.getNoTenant<GeneralMetricsResponse>(`/organizations/${organizationId}/metrics/metadata`),
	getApiKeysMeters: async (organizationId: string): Promise<ApiKeysMetricsResponse> =>
		demoApi.getNoTenant<ApiKeysMetricsResponse>(`/organizations/${organizationId}/metrics/apikeys`),

	getMeters: (organizationId: string, module: MetersModule) =>
		fetchOrganizationMeters(demoOrganizationMetricsApi, organizationId, module),
}
